import { forwardRef } from "react";
import {
  type LinkProps,
  // biome-ignore lint/style/noRestrictedImports: We're creating our wrapped Link version here
  Link as RouterLink,
  useLocation,
} from "react-router-dom";

export const Link = forwardRef<
  HTMLAnchorElement,
  LinkProps & { resetHistory?: boolean }
>(({ resetHistory, ...props }, ref) => {
  const location = useLocation();

  const locationHistoryStack = location.state?.locationHistoryStack || [];

  return (
    <RouterLink
      ref={ref}
      {...props}
      state={{
        ...props.state,
        locationHistoryStack: resetHistory
          ? []
          : props.replace
            ? locationHistoryStack
            : [location, ...locationHistoryStack],
      }}
    />
  );
});
